import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Platform from "@/pages/Platform";
import AISecurity from "@/pages/AISecurity";
import Governance from "@/pages/Governance";
import Assurance from "@/pages/Assurance";
import WhyMeira from "@/pages/WhyMeira";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Verify from "@/pages/Verify";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/platform" element={<Platform />} />
          <Route path="/ai-security" element={<AISecurity />} />
          <Route path="/governance" element={<Governance />} />
          <Route path="/assurance" element={<Assurance />} />
          <Route path="/why-meira" element={<WhyMeira />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
      <Toaster position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
